import React from 'react';
import './App.css';
import RealDataMap from './RealDataMap';

function App() {
  return (
    <div className="App">
      <RealDataMap />
    </div>
  );
}

export default App;
